export { ModalDeclaracoes } from './modal-declaracoes'
export * from './tipos'
